export const enum ETenant {
  NIEUWEGEIN = 1
}
